export var emptyFile = {
  fullName: "empty.py",
  shortName: "empty.py",
  originalContent: "",
  content: ""
};
var defaultSrcContent = "# No ProgrammingExercise has been loaded.\n# This is the default file main.py\n\nfrom .utils import greeting, getLocality\n\ndef greetWorld():\n  print(greeting(getLocality()))\n\ndef foo():\n  print(\"foo!\")\n";
var defaultTestContent = "# No ProgrammingExercise has been loaded.\n# This is the default file test.py\n\nfrom .main import greetWorld\n\ngreetWorld()\n";
var defaultUtilsContent = "# No ProgrammingExercise has been loaded.\n# This is the default file utils.py\n\n# Mutually recursive imports are disallowed.\n# Try uncommenting the line below!\n#from .main import foo\n\ndef greeting(recipient):\n  return \"Hello \" + recipient + \"!\"\n\ndef getLocality():\n  return \"world\"\n";
export var exampleFiles = [{
  fullName: "main.py",
  shortName: "main.py",
  originalContent: defaultSrcContent,
  content: defaultSrcContent
}, {
  fullName: "utils.py",
  shortName: "utils.py",
  originalContent: defaultUtilsContent,
  content: defaultUtilsContent
}, {
  fullName: "test.py",
  shortName: "test.py",
  originalContent: defaultTestContent,
  content: defaultTestContent
}];